// UT Knoxville's undergraduate majors (#2652). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog page "Undergraduate Degrees,
// Majors, Concentrations, Minors, and Certificates" (catalog.utk.edu,
// catoid=56, navoid=12115), which lists every program by college. Each
// "<Name> Major, <degree>" line is one major; its concentrations, five-year
// BS/MS listings and uTrack versions of the same major are folded into it
// ("(uTrack Requirements)" and "(Arts and Sciences)" are dropped from the
// degree). Minors, certificates and non-degree programs are left out, as are
// the Nursing Accelerated Track and RN Track (not first-year entry). Notes
// and the Nursing flag quote the First-Year Student Applications page (the
// college file's `firstYear` source). The KB's majors list was the starting
// point; the catalog wins.
const majors = {
    "slug": "university-of-tennessee-knoxville",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in UT Knoxville's 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations, minors, certificates and the nursing tracks for registered nurses and second-degree students are left out.",
    "groups": [
        {
            "name": "Herbert College of Agriculture",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Bioinformatics",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Business",
                    "degree": "BS in Agricultural and Resource Economics"
                },
                {
                    "name": "Natural Resource and Environmental Economics",
                    "degree": "BS in Agricultural and Resource Economics"
                },
                {
                    "name": "Agricultural Leadership, Education, and Communications",
                    "degree": "BS in Agriculture"
                },
                {
                    "name": "Animal and Veterinary Science",
                    "degree": "BS in Animal Science"
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": "BS in Biosystems Engineering"
                },
                {
                    "name": "Construction Science and Management",
                    "degree": "BS in Construction Science and Management"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS in Environmental Science"
                },
                {
                    "name": "Food Science",
                    "degree": "BS in Food Science"
                },
                {
                    "name": "Forestry",
                    "degree": "BS in Forestry"
                },
                {
                    "name": "Plant Sciences",
                    "degree": "BS in Plant Sciences"
                },
                {
                    "name": "Wildlife and Fisheries Science",
                    "degree": "BS in Wildlife and Fisheries Science"
                }
            ]
        },
        {
            "name": "College of Architecture and Design",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "Bachelor of Architecture"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA in Graphic Design"
                },
                {
                    "name": "Interior Architecture",
                    "degree": "BS in Interior Architecture"
                }
            ],
            "note": "A portfolio of your artwork is recommended but not required.",
            "noteSource": "firstYear"
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Cinema Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "College Scholars",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Programs",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Geographic Information Science and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Geology and Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Programs",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Pre-Professional Programs",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS, ACS Certified"
                }
            ]
        },
        {
            "name": "Haslam College of Business",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS in Business Administration"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS in Business Administration"
                },
                {
                    "name": "Economics",
                    "degree": "BS in Business Administration"
                },
                {
                    "name": "Finance",
                    "degree": "BS in Business Administration"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BS in Business Administration"
                },
                {
                    "name": "Management",
                    "degree": "BS in Business Administration"
                },
                {
                    "name": "Marketing",
                    "degree": "BS in Business Administration"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BS in Business Administration"
                }
            ]
        },
        {
            "name": "College of Communication and Information",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Communication Studies",
                    "degree": "BA in Communication"
                },
                {
                    "name": "Advertising",
                    "degree": "BS in Communication"
                },
                {
                    "name": "Journalism and Media",
                    "degree": "BS in Communication"
                },
                {
                    "name": "Public Relations",
                    "degree": "BS in Communication"
                },
                {
                    "name": "Communication and Information",
                    "degree": "BS in Communication and Information"
                },
                {
                    "name": "Information Sciences",
                    "degree": "BS in Information Sciences"
                }
            ]
        },
        {
            "name": "College of Education, Health, and Human Sciences",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Recreational Therapy",
                    "degree": "BS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "Audiology and Speech Pathology",
                    "degree": "BS in Audiology and Speech Pathology"
                },
                {
                    "name": "Deaf Studies",
                    "degree": "BS in Education"
                },
                {
                    "name": "Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Special Education",
                    "degree": "BS in Education"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS in Health and Human Sciences"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS in Health and Human Sciences"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS in Kinesiology"
                },
                {
                    "name": "Public Health",
                    "degree": "BS in Public Health"
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "BS in Retail, Hospitality, and Tourism Management"
                },
                {
                    "name": "Retail and Merchandising Management",
                    "degree": "BS in Retail, Hospitality, and Tourism Management"
                }
            ]
        },
        {
            "name": "College of Emerging and Collaborative Studies",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Applied Artificial Intelligence",
                    "degree": "BS in Applied Artificial Intelligence"
                },
                {
                    "name": "Applied Cybersecurity",
                    "degree": "BS in Applied Cybersecurity"
                },
                {
                    "name": "Data Science",
                    "degree": "BS in Data Science"
                },
                {
                    "name": "Innovative Transdisciplinary Studies",
                    "degree": "BS in Innovative Transdisciplinary Studies"
                }
            ]
        },
        {
            "name": "Tickle College of Engineering",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS in Aerospace Engineering"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS in Biomedical Engineering"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS in Chemical Engineering"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS in Civil Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS in Computer Engineering"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS in Computer Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS in Electrical Engineering"
                },
                {
                    "name": "Applied Engineering",
                    "degree": "BS in Engineering"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS in Environmental Engineering"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS in Industrial Engineering"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS in Materials Science and Engineering"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS in Mechanical Engineering"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BS in Nuclear Engineering"
                }
            ],
            "note": "Admission to the college uses your core GPA and test scores, and the class may be limited by space.",
            "noteSource": "firstYear"
        },
        {
            "name": "Natalie L. Haslam College of Music",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                }
            ],
            "note": "Depending on the concentration you choose, you may need to audition, interview or both.",
            "noteSource": "firstYear"
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BS in Nursing",
                    "flag": "Test scores are required, and you must mark Nursing as your first-choice major to be considered for direct entry.",
                    "flagSource": "firstYear"
                }
            ]
        },
        {
            "name": "College of Social Work",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BS in Social Work"
                }
            ]
        },
        {
            "name": "Howard H. Baker Jr. School of Public Policy and Public Affairs",
            "source": {
                "label": "UT Knoxville 2026-2027 Undergraduate Catalog, Undergraduate Degrees, Majors, Concentrations, Minors, and Certificates",
                "url": "https://catalog.utk.edu/content.php?catoid=56&navoid=12115"
            },
            "majors": [
                {
                    "name": "Civic and Constitutional Thought",
                    "degree": "BA"
                },
                {
                    "name": "Public Affairs",
                    "degree": "BS in Public Affairs"
                }
            ]
        }
    ]
};

export default majors;
